import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { API } from "../config";
import { Mountain } from "lucide-react";

const IMGS = [
  "https://images.unsplash.com/photo-1650144944868-b3c9866b8264?q=80&w=1400&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1558980664-10e7170b5df9?q=80&w=1400&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1786497219063-e30202986565?q=80&w=1400&auto=format&fit=crop",
];

export default function Routes() {
  const { t, lang } = useLang();
  const [content, setContent] = useState(null);
  useEffect(() => { axios.get(`${API}/content`).then(({ data }) => setContent(data)).catch(() => {}); }, []);
  const ov = content?.routes?.[lang];
  const r = ov && ov.title
    ? { eyebrow: ov.eyebrow || t.routes.eyebrow, title: ov.title, items: ov.items?.length ? ov.items : t.routes.items }
    : t.routes;
  return (
    <section id="routes" className="border-y-2 border-topacio-ink bg-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <p className="eyebrow mb-4">{r.eyebrow}</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-topacio-ink mb-12">{r.title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {r.items.map((it, i) => (
            <motion.div key={i} data-testid={`route-card-${i}`}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`group card-brutal overflow-hidden hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#111] transition-[transform,box-shadow] ${i === 1 ? "md:-translate-y-4" : ""}`}>
              <div className="aspect-[3/2] overflow-hidden border-b-2 border-topacio-ink bg-topacio-sand">
                <img src={it.img || IMGS[i] || IMGS[0]} alt={it.t} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-7">
                {it.tag && (
                  <span className="badge-brutal bg-topacio-red text-white mb-3">
                    <Mountain className="w-3 h-3" />{it.tag}
                  </span>
                )}
                <h3 className="font-display text-xl font-bold text-topacio-ink">{it.t}</h3>
                <p className="text-sm text-topacio-faded mt-2 leading-relaxed">{it.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
